import React from 'react';
import './ClientFeedbackSection.css';

import TTCS from '../Images/TTCS.png';
import swagino from '../Images/swagino.png';
import OrderEye from '../Images/OrderEye.png';
import corizo from '../Images/corizo.png';
import careerdwar from '../Images/careerdwar.png';
import Learncoz from '../Images/Learncoz.png';

import user1 from '../Images/user1.png';
import user2 from '../Images/user2.png';
import user3 from '../Images/user3.png';
import user4 from '../Images/wom.jpg';
import user5 from '../Images/user.jpg';
import user6 from '../Images/user6.png';

const ClientFeedbackSection = ({ feedbackList = [] }) => {
  const reviews = [
    {
      name: "Rahul Mehta",
      text: "Before SkillsHap, we struggled with scattered placement efforts and poor student preparation...",
      image: user1,
    },
    {
      name: "Neha Kapoor",
      text: "We wanted a way to plug career services into our learning model without building from scratch...",
      image: user4,
    },
    {
      name: "Abhinav Sharma",
      text: "We’ve been running technical courses for years, but the placement side always lagged...",
      image: user2,
    },
    {
      name: "Sanya Reddy",
      text: "As a hiring partner, we get flooded with unprepared profiles. With SkillsHap, we get job-ready candidates...",
      image: user6,
    },
    {
      name: "Sandeep Chauhan",
      text: "SkillsHap has filled the critical gap between academics and employability...",
      image: user3,
    },
    {
      name: "Anjali Deshmukh",
      text: "We hired 3 candidates through the SkillsHap platform — every one of them was prepared, professional...",
      image: user5,
    },
  ];

  // ✅ Define the arrays to fix the error
  const leftToRight = reviews.slice(0, 3); // First 3 reviews
  const rightToLeft = reviews.slice(3);    // Remaining reviews

  return (
    <section className="feedback-section">
      <h2 className="feedback-title">
        Client <span className="highlight">Feedbacks</span>
      </h2>

      <div className="dual-carousel">
        {/* Left to Right */}
        <div className="carousel-window left-to-right">
          <div className="carousel-track">
            {[...leftToRight, ...leftToRight].map((review, index) => (
              <div className="review-card" key={`ltr-${index}`}>
                <div className="review-bubble">
                  <div className="review-content">
                    <img src={review.image} alt={review.name} className="review-img" />
                    <div className="text-area">
                      <p className="review-text">“{review.text}”</p>
                      <p className="review-name">— {review.name}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right to Left */}
        <div className="carousel-window right-to-left">
          <div className="carousel-track">
            {[...rightToLeft, ...rightToLeft].map((review, index) => (
              <div className="review-card" key={`rtl-${index}`}>
                <div className="review-bubble">
                  <div className="review-content">
                    <img src={review.image} alt={review.name} className="review-img" />
                    <div className="text-area">
                      <p className="review-text">“{review.text}”</p>
                      <p className="review-name">— {review.name}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

<div className="collab-logos">
 
  
</div>

    </section>
  );
};

export default ClientFeedbackSection;
